const DESKTOP_BREAKPOINT = "1024px";
const categories = document.getElementById("categories");
const isBackForwardNavigation = () => {
  const navEntry = performance.getEntriesByType("navigation")[0];
  return (navEntry == null ? void 0 : navEntry.type) === "back_forward";
};
const isMobileInlineCategories = () => {
  if (!(categories == null ? void 0 : categories.classList.contains("categories--inline-mobile"))) {
    return false;
  }
  return !window.matchMedia(`(min-width: ${DESKTOP_BREAKPOINT})`).matches;
};
const stickyHeaderOffset = () => {
  const stickyHeader = document.querySelector("[data-sticky-header]");
  return (stickyHeader == null ? void 0 : stickyHeader.offsetHeight) || 0;
};
const scrollToTarget = (target, focusTarget) => {
  const top = target.getBoundingClientRect().top + window.scrollY - stickyHeaderOffset();
  window.scrollTo({ top: Math.max(top, 0), behavior: "smooth" });
  if (!focusTarget) {
    return;
  }
  if ("onscrollend" in window) {
    window.addEventListener("scrollend", () => focusTarget.focus({ preventScroll: true }), { once: true });
  } else {
    setTimeout(() => focusTarget.focus({ preventScroll: true }), 400);
  }
};
const shouldScrollToSelectedSection = () => {
  if (!window.location.pathname.includes("/empty")) {
    return false;
  }
  if (!isMobileInlineCategories()) {
    return false;
  }
  return !isBackForwardNavigation();
};
const scrollToSelectedSection = () => {
  if (!shouldScrollToSelectedSection()) {
    return;
  }
  const selectedSection = document.getElementById("selected-knowledge-section");
  if (!selectedSection) {
    return;
  }
  scrollToTarget(selectedSection, selectedSection.querySelector(".accordion-header"));
};
const shouldScrollToFaqArticle = () => {
  if (!window.location.pathname.includes("/faq")) {
    return false;
  }
  if (!isMobileInlineCategories()) {
    return false;
  }
  return !isBackForwardNavigation();
};
const scrollToFaqArticle = () => {
  if (!shouldScrollToFaqArticle()) {
    return;
  }
  const article = document.getElementById("knowledge-base-article");
  if (!article) {
    return;
  }
  scrollToTarget(article, article.querySelector("h2"));
};
document.addEventListener("DOMContentLoaded", () => {
  const initializeAriaExpanded = (header) => {
    const content = header.nextElementSibling;
    const isExpanded = header.classList.contains("active") || content.style.display === "block" || !content.classList.contains("hidden");
    header.setAttribute("aria-expanded", isExpanded);
  };
  document.querySelectorAll(".accordion-header").forEach((header) => {
    initializeAriaExpanded(header);
  });
  document.querySelectorAll(".accordion-header").forEach((header) => {
    header.addEventListener("click", () => {
      header.classList.toggle("active");
      const content = header.nextElementSibling;
      const isExpanded = header.classList.contains("active");
      header.setAttribute("aria-expanded", isExpanded);
      if (header.classList.contains("active")) {
        content.style.display = "block";
      } else {
        content.style.display = "none";
      }
    });
  });
  scrollToSelectedSection();
  scrollToFaqArticle();
});
const showCategoriesButton = document.querySelectorAll("[id=show-categories-btn]");
const closeCategoriesButton = document.querySelectorAll("[id=close-categories-btn]");
showCategoriesButton.forEach((button) => {
  button.addEventListener("click", function() {
    categories.classList.remove("hidden");
    document.body.classList.add("overflow-hidden");
    categories.focus();
  });
});
closeCategoriesButton.forEach((element) => {
  element.addEventListener("click", () => {
    hideCategories();
  });
});
window.matchMedia(`(min-width: ${DESKTOP_BREAKPOINT})`).addEventListener("change", () => {
  hideCategories();
});
function hideCategories() {
  if (!categories || categories.classList.contains("categories--inline-mobile")) {
    document.body.classList.remove("overflow-hidden");
    return;
  }
  categories.classList.add("hidden");
  document.body.classList.remove("overflow-hidden");
}
